import Chart from "chart.js";
export default class ChartPlugin {
    pluginConfig: any = {
        id: 'my-plugin',
        beforeRender: function (chart) {
            if (chart.config.options.showAllTooltips) {
                // create an array of tooltips
                // we can't use the chart tooltip because there is only one tooltip per chart
                chart.pluginTooltips = [];
                chart.config.data.datasets.forEach(function (dataset, i) {
                    chart.getDatasetMeta(i).data.forEach(function (sector, j) {
                        var itemValue = chart.config.data.datasets[i].data[sector._index];
                        if (itemValue && (+itemValue) > 0) {
                            var tooltipItem = new Chart.Tooltip({
                                _chart: chart.chart,
                                _chartInstance: chart,
                                _data: chart.data,
                                _options: chart.options.tooltips,
                                _active: [sector]
                            }, chart);
                            chart.pluginTooltips.push(tooltipItem);
                        }
                    });
                });
                // turn off normal tooltips
                chart.options.tooltips.enabled = false;
            }
        },

        afterDraw: function (chart, easing) {
            if (chart.config.options.showAllTooltips) {
                // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
                if (!chart.allTooltipsOnce) {
                    if (easing !== 1)
                        return;
                    chart.allTooltipsOnce = true;
                }
                // turn on tooltips
                chart.options.tooltips.enabled = true;
                Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
                    tooltip.initialize();
                    tooltip.update();
                    // we don't actually need this since we are not animating tooltips
                    tooltip.pivot();
                    tooltip.transition(easing).draw();
                });
                chart.options.tooltips.enabled = false;
            }
        }

    }
    barPluginConfig: any = {
        id: 'my-plugin',
        afterDatasetsDraw: function (context, easing) {
            var ctx = context.chart.ctx;
            context.data.datasets.forEach(function (dataset) {
                for (var i = 0; i < dataset.data.length; i++) {
                    if (dataset.data[i] != 0) {
                        var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                        var textY = (model.y + (context.config.type == "line" ? 7 : 40)) - 15;
                        var textX = model.x + (context.config.type == "line" ? -5 : -3);
                        ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'bold', Chart.defaults.global.defaultFontFamily);
                        ctx.textAlign = 'start';
                        ctx.textBaseline = 'middle';
                        ctx.fillStyle = context.config.type == "line" ? "black" : "white";
                        ctx.save();
                        ctx.translate(textX, textY);
                        ctx.fillText(dataset.data[i], 0, 0);
                        ctx.restore();
                    }
                }
            });
        }
    }
    DEFAULT_OPTION = {
        responsive: true,
        maintainAspectRatio: false
    }
};